declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function updateGoogleConsentMode(acceptedCategories: string[]) {
  if (typeof window.gtag !== 'function') return;

  const hasAnalytics = acceptedCategories.includes('analytics');
  const hasMarketing = acceptedCategories.includes('marketing');
  const hasFunctional = acceptedCategories.includes('functional');

  window.gtag('consent', 'update', {
    analytics_storage: hasAnalytics ? 'granted' : 'denied',
    ad_storage: hasMarketing ? 'granted' : 'denied',
    ad_user_data: hasMarketing ? 'granted' : 'denied',
    ad_personalization: hasMarketing ? 'granted' : 'denied',
    functionality_storage: hasFunctional ? 'granted' : 'denied',
    personalization_storage: hasFunctional ? 'granted' : 'denied',
  });
}
